"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSetMeteringBuildingLinksMutation = exports.useFetchMeteringBuildingsQuery = exports.useSetMeteringSyncModeMutation = exports.useSyncBuildingFromDTMutation = exports.useDeleteBuildingChangeEventMutation = exports.useFetchBuildingAuditLogQuery = exports.useFetchBuildingHistoryQuery = exports.useUpdateBuildingMutation = exports.useDeleteBuildingMutation = exports.useFetchDevelopmentsQuery = exports.useFetchBuildingQuery = exports.useSearchBuildingsQuery = exports.useFetchClientBuildingsQuery = exports.useCreateBuildingMutation = exports.buildingApi = void 0;
// api/buildingApi.ts
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.buildingApi = (0, react_1.createApi)({
    reducerPath: "buildingApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["buildings"],
    endpoints: function (builder) { return ({
        createBuilding: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/building/create",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["buildings"],
        }),
        fetchClientBuildings: builder.query({
            query: function (obj) { return ({
                url: "/v1/building/all",
                method: "GET",
                params: {
                    clientId: obj.clientId,
                    page: obj.page,
                    limit: obj.limit,
                },
            }); },
            providesTags: ["buildings"],
        }),
        searchBuildings: builder.query({
            query: function (obj) {
                var params = {
                    clientId: obj.clientId,
                    page: obj.page || 1,
                    limit: obj.limit || 10,
                };
                if (obj.search)
                    params.search = obj.search;
                if (obj.source)
                    params.source = obj.source;
                if (obj.type)
                    params.type = obj.type;
                if (obj.isActive !== undefined)
                    params.isActive = obj.isActive;
                if (obj.ownerName)
                    params.ownerName = obj.ownerName;
                return {
                    url: "/v1/building/all",
                    method: "GET",
                    params: params,
                };
            },
            providesTags: ["buildings"],
        }),
        // RF-1 A3: distinct developments for the Development Name dropdown.
        fetchDevelopments: builder.query({
            query: function (clientId) { return ({
                url: "/v1/building/developments",
                method: "GET",
                params: { clientId: clientId },
            }); },
            providesTags: ["buildings"],
        }),
        fetchBuilding: builder.query({
            query: function (buildingId) { return ({
                url: "/v1/building/fetch",
                method: "GET",
                params: {
                    _id: buildingId,
                },
            }); },
            providesTags: ["buildings"],
        }),
        deleteBuilding: builder.mutation({
            query: function (_a) {
                var buildingId = _a.buildingId, performedBy = _a.performedBy, reason = _a.reason;
                return ({
                    url: "/v1/building/remove",
                    method: "DELETE",
                    params: __assign({ _id: buildingId, performedBy: performedBy }, (reason ? { reason: reason } : {})),
                });
            },
            invalidatesTags: ["buildings"],
        }),
        updateBuilding: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/building/update",
                method: "PUT",
                body: obj,
            }); },
            invalidatesTags: ["buildings"],
        }),
        fetchBuildingHistory: builder.query({
            query: function (buildingId) { return ({
                url: "/v1/building/history",
                method: "GET",
                params: { _id: buildingId },
            }); },
            providesTags: function (_result, _err, buildingId) { return [{ type: "buildings", id: "history:".concat(buildingId) }]; },
        }),
        fetchBuildingAuditLog: builder.query({
            query: function (_a) {
                var buildingId = _a.buildingId, action = _a.action, includeDeleted = _a.includeDeleted;
                return ({
                    url: "/v1/building/audit-log",
                    method: "GET",
                    params: __assign(__assign({ _id: buildingId }, (action ? { action: action } : {})), (includeDeleted ? { includeDeleted: true } : {})),
                });
            },
            providesTags: function (_result, _err, arg) { return [{ type: "buildings", id: "audit:".concat(arg.buildingId) }]; },
        }),
        deleteBuildingChangeEvent: builder.mutation({
            query: function (_a) {
                var eventId = _a.eventId, performedBy = _a.performedBy, reason = _a.reason;
                return ({
                    url: "/v1/building/audit-log/event",
                    method: "DELETE",
                    body: { eventId: eventId, performedBy: performedBy, reason: reason },
                });
            },
            invalidatesTags: function (_result, _err, arg) { return [
                { type: "buildings", id: "audit:".concat(arg.buildingId) },
                { type: "buildings", id: "history:".concat(arg.buildingId) },
            ]; },
        }),
        // MC&LCC-1: how ONE asset takes its metering company's data. Kept off `updateBuilding`, which
        // requires an edit classification, effective date and reason — too heavy for an integration toggle.
        setMeteringSyncMode: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/building/metering-sync-mode",
                method: "PATCH",
                body: obj,
            }); },
            invalidatesTags: ["buildings"],
        }),
        // MC&LCC-1.2: the metering company's buildings, for the assignment screen's dropdown.
        fetchMeteringBuildings: builder.query({
            query: function (_a) {
                var clientId = _a.clientId;
                return ({ url: "/v1/building/metering-buildings", method: "GET", params: { clientId: clientId } });
            },
        }),
        // Batched: the screen saves on demand, not on every change, so one press commits every touched row.
        setMeteringBuildingLinks: builder.mutation({
            query: function (body) { return ({ url: "/v1/building/metering-building-links", method: "PATCH", body: body }); },
            invalidatesTags: ["buildings"],
        }),
        syncBuildingFromDT: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/building/sync-digital-twin",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["buildings"],
        }),
    }); },
});
exports.useCreateBuildingMutation = exports.buildingApi.useCreateBuildingMutation, exports.useFetchClientBuildingsQuery = exports.buildingApi.useFetchClientBuildingsQuery, exports.useSearchBuildingsQuery = exports.buildingApi.useSearchBuildingsQuery, exports.useFetchBuildingQuery = exports.buildingApi.useFetchBuildingQuery, exports.useFetchDevelopmentsQuery = exports.buildingApi.useFetchDevelopmentsQuery, exports.useDeleteBuildingMutation = exports.buildingApi.useDeleteBuildingMutation, exports.useUpdateBuildingMutation = exports.buildingApi.useUpdateBuildingMutation, exports.useFetchBuildingHistoryQuery = exports.buildingApi.useFetchBuildingHistoryQuery, exports.useFetchBuildingAuditLogQuery = exports.buildingApi.useFetchBuildingAuditLogQuery, exports.useDeleteBuildingChangeEventMutation = exports.buildingApi.useDeleteBuildingChangeEventMutation, exports.useSyncBuildingFromDTMutation = exports.buildingApi.useSyncBuildingFromDTMutation, exports.useSetMeteringSyncModeMutation = exports.buildingApi.useSetMeteringSyncModeMutation, exports.useFetchMeteringBuildingsQuery = exports.buildingApi.useFetchMeteringBuildingsQuery, exports.useSetMeteringBuildingLinksMutation = exports.buildingApi.useSetMeteringBuildingLinksMutation;
